export default (el) => {
	const shape = el.querySelector('.shape');
	const items = el.querySelectorAll('li');

	items.forEach((item) => {
		item.addEventListener('mouseover', () => {
			position(item);
		})

		item.addEventListener('mouseout', () => {
			position();
		})
	});

	function position(active = false) {

		const elRect = el.getBoundingClientRect();

		if (!active) {
			active = el.querySelector('li.active');
		}

		if (!active) { return }

		const activeRect = active.getBoundingClientRect();
		const offset = (activeRect.left - elRect.left) + (activeRect.width / 2);
		shape.style.left = offset + 'px';
		shape.classList.add('active');

	}

	
	window.addEventListener('load', function() {
		position();
	});
	window.addEventListener('resize', function() {
		position();
	});

};
